import { DropdownField, DropdownItem } from '@bybeam/platform-types';

export function mapParentChildKeys(options: DropdownItem[]): DropdownItem[] {
  return options.map((option) => ({
    ...option,
    ...('children' in option &&
      option.children && {
        children: option.children.map((child) => ({
          ...child,
          value: `${option.value}:${child.value}`,
        })),
      }),
  }));
}

export function isMultiple(field: DropdownField): boolean {
  return field.props && 'multiple' in field.props && field.props.multiple;
}
